<app-table
    tableKey="dashboardMovementRestrictions"
    [gridData]="$any(store.data.getWorks())"
    [hideCheckboxes]="true"
    [columns]="columns()"
    translatePrefix="dashboard.movementRestrictions."
    [showSearch]="false"
    [showColumnVisiblity]="false"
    [showExport]="false"
    [showClearFilter]="false"
    [additionalFilter]="additionalFilters()"
    [refreshCallback]="store.api.getWorks"
    [refreshCallbackFragment]="getRestrictionsFrag"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
>
</app-table>
